module.exports = __webpack_public_path__ + "e17b64a102cf5c106c63aa9c0cb559b1.gltf";